#import "../../../../CorporateChartOfAccountsFields.graphql"
mutation CorporateChartOfAccountCreate(
  $input: CorporateChartOfAccountCreateInput!
) {
  corporateChartOfAccountCreate(input: $input) {
    corporateChartOfAccount {
      ...CorporateChartOfAccountsFields
    }
  }
}
